import TeamzIcon from "@/assets/teamz.svg";

import { cn } from "@/lib/utils";

export function LoaderTeamz({ className }: { className?: string }) {
  return (
    <div className={cn("flex h-[calc(100%-8px)] w-full items-center justify-center", className)}>
      <TeamzIcon className="size-20 animate-pulse" />
    </div>
  );
}
